<template>
  <div class="head-login-sticky medium fat-font-family">
    <div class="wrapper">
      <AutoFitComponent>
        <div class="content">
          <template v-if="userinfo && userinfo.user_id">
            <p v-if="userinfo.nickname !== undefined">
              {{ $t('card.nickname') }} {{ userinfo.nickname }}
            </p>
            <p>{{ $t('game.userId') }}{{ userinfo.role_id }}</p>
            <p>{{ $t('game.mainCityLevel_20195') }}{{ userinfo.rank }}</p>
          </template>
          <template v-else>
            {{ $t('text.loginFirst') }}&nbsp;
            <span class="btn-link login-btn" @click="$emit('login')">{{ $t('text.login') }} ></span>
          </template>
        </div>
      </AutoFitComponent>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'HomeStickyFat',
  data() {
    return {}
  },
  // 组件方法
  methods: {},
  // 计算属性
  computed: {
    ...mapState({
      userinfo: (state) => state.user.userInfo,
    }),
  },
  // 侦听器
  watch: {},
  // import的组件需要声明
  components: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.head-login-sticky {
  position: fixed;
  z-index: 11;
  width: 100%;
  height: 32px;
  background: #0c3656;
  left: 0;
  top: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 14px;
  line-height: 2;
  padding: 0 10px;
  .wrapper {
    max-width: 100%;
  }
  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  p {
    margin: 0 5px;
  }
}
</style>
